module.exports = __webpack_public_path__ + "static/media/catu-logo.441b9fa4.png";